import axios, { AxiosRequestConfig } from "axios";
import { loadStytch } from "@/lib/stytch.ts";
import { useDevOverridesStore } from "@/lib/hooks/admin/use-dev-overrides";
import { isNewBackendPath, usesNewBackend } from "@/lib/api/new-backend-path";

export const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const NEW_BACKEND_URL = import.meta.env.VITE_NEW_BACKEND_URL;

const onNewBackend = ({ url, method }: AxiosRequestConfig) =>
  usesNewBackend(url, method);

const skipsPhiMask = (url: AxiosRequestConfig["url"]) =>
  typeof url === "string" && isNewBackendPath(url);

export const fetchApi = <T>(
  options: AxiosRequestConfig,
  authenticated: boolean = true,
) => {
  const headers = options.headers || {};

  if (authenticated) {
    const client = loadStytch();
    const tokens = client.session.getTokens();

    if (tokens?.session_token) {
      headers["Authorization"] = `${tokens?.session_jwt}`;
    }
  }

  if (useDevOverridesStore.getState().hidePhiPii && !skipsPhiMask(options.url)) {
    headers["x-mask-phi-pii"] = "1";
  }

  const baseURL =
    options.baseURL ??
    (NEW_BACKEND_URL && onNewBackend(options) ? NEW_BACKEND_URL : undefined);

  return axiosClient.request<T>({
    ...options,
    ...(baseURL ? { baseURL } : {}),
    headers,
  });
};
